import React from 'react';
import { Divider } from 'rsuite';
import { useHistory } from "react-router-dom";
import { InfoIcon } from '../../svg/iconsSvg';

const AddPolicySuccess = ({plate, policyId}) => {

    const history = useHistory();

    const goToMyPolicies = () => {
        history.push('/app/my-policies');
    }

    return(
        <div className="steps_container" >
            <div  style={{padding: '1rem 2rem 0 2rem'}}>
                <h6 style={{marginBottom: '4px'}}>{policyId}</h6>
                <h6 style={{fontWeight: 'normal'}}>{plate}</h6>
            </div>
            <Divider />
            <div style={{textAlign: 'center', margin: '28px 0'}}>
                <img src="/img/success-pay.png" alt="Success" style={{width:"130px"}}></img>
            </div>
            
            <Divider />
            <div className="steps_container-checkbox">
                <InfoIcon size="22" style={{marginLeft: '2px'}}/>
                <div>Успешно добавена полица "Гражданска Отговорност"</div>
            </div>
            <Divider />
            <div className="steps_container-checkbox">
                <InfoIcon size="28" style={{marginLeft: '2px'}}/>
                <div>Ще получиш известие при предстояща вноска и при изтичане на полицата</div>
            </div>
            <Divider />

            <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-main" type="submit" onClick={goToMyPolicies}>Моите полици</button>
        </div>
    )
}

export default AddPolicySuccess;